import { render, staticRenderFns } from "./checkInformation.vue?vue&type=template&id=2c015d64&scoped=true&"
import script from "./checkInformation.vue?vue&type=script&lang=js&"
export * from "./checkInformation.vue?vue&type=script&lang=js&"
import style0 from "./checkInformation.vue?vue&type=style&index=0&id=2c015d64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c015d64",
  null
  
)

export default component.exports